<template>
  <div class="bg-header-inst" style="height: 400px; margin-top: -738px">
    <v-container>
      <v-card
        width="320"
        class="transparent"
        elevation="0"
        style="padding-top: 70px !important"
      >
        <h1 class="">
          <span class="mx-auto text-center text-header white--text text-left"
            >Conheça o serviço <strong>Web Email</strong></span
          >
        </h1>
      </v-card>

      <v-card-text
        style="width: 400px; font-size: 20px !important"
        class="mt-12 white--text text-subtitle-1 text-sub-header margin-line font-weight-regular mx-n4"
      >
        Crie, hospede sem burocracia os e-mails da sua empresa. O nosso serviço
        de web e-mail serve para todas as empresas.
      </v-card-text>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "HeaderEmail",
};
</script>

<style scoped>
strong {
  color: white;
  text-shadow: 1px 1px 2px black, 0 0 25px blue, 0 0 5px darkblue;
}
.text-header {
  font-family: "Fira Sans Condensed", sans-serif;
  line-height: 42px;
  font-size: 38px;
  font-weight: 500;
}

:root {
  --text-color: #616266;
  --header: #32363b;
  --background: #32363b;
}

.bg-header-inst {
  background-image: linear-gradient(
      295deg,
      rgba(15, 15, 16, 0.68),
      rgb(0, 0, 0)
    ),
    url("https://img.freepik.com/free-photo/futuristic-smart-city-with-5g-global-network-technology_53876-98438.jpg");
  background-size: cover;
  background-color: #efefef;
}
</style>
